module.exports = __webpack_public_path__ + "assets/img/teacher (19).534d5d86.png";